/* eslint-disable */
import React from "react";
import { Navigate, useLocation, Outlet } from "react-router-dom";
import useStore from "../store/store";

const AuthGuard = () => {
  const location = useLocation();
  const user = useStore((state) => state.user);

  if (!user?.token) {
    return <Navigate to="/signin" state={{ from: location }} replace />;
  }

  return <Outlet />;
};

export default AuthGuard;
